module.exports = __webpack_public_path__ + "img/AIwitter1.223262a3.png";